import React, { useEffect, useRef, useState } from "react";
import "@tldraw/tldraw/tldraw.css";
import { useSync } from "@tldraw/sync";
import {
  Tldraw,
  ToolbarItem,
  useTldrawUser,
  useEditor,
  DefaultColorStyle,
  Editor,
  TLGeoShape,
  TLShapePartial,
  createShapeId,
  PageItemSubmenu,
  exportToBlob,
} from "@tldraw/tldraw";
import { getBookmarkPreview } from "./sync/getBookmarkPreview.tsx";
import { multiplayerAssetStore } from "./sync/multiplayerAssetStore.tsx";
import { TLDRAW_WORKER_URL } from "./sync/config.js";
import { useSelector } from "react-redux";
import axios from "axios";
import apiClient from "../../apiClient/index.js";
import { UPATEBOARD } from "../../apiClient/apiEndpoints.js";
import * as htmlToImage from "html-to-image";

const Board = ({ title, photoCount, roomId, access }) => {
  const configData = useSelector((state) => state.configSlice);
  const userData = useSelector((state) => state.userSlice);
  const token = useSelector((state) => state.userSlice).token;
  const API_URL = configData?.config?.API_URL;
  const divRef = useRef(null);
  const editorRef = useRef(null)

  const [userPreferences, setUserPreferences] = useState({
    id: "user-" + Math.random(),
    name: userData?.user?.name || "External User",
  });

  const user = useTldrawUser({ userPreferences, setUserPreferences });

  const saveThumbnail = async (editor) => {
    const blob = await exportToBlob({ editor, ids: [], format: "png" }).catch(err=>{});
    if(!blob)return;
    const formData = new FormData();
    formData.append("file", blob, "image.jpg");
    const apiUrl = `${configData.config.UNO_URL}/api/resource/whiteBoard/image/${roomId}`;
    axios
      .post(apiUrl, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      })
      .then(async (response) => {
        let body = {
          thumbnail: response.data.url,
        };
        await apiClient.put(`${API_URL}${UPATEBOARD}/${roomId}`, body);
      })
      .catch((error) => {
        console.error("Error uploading image:", error);
      });
  };
  var interval;
  const handleMount = (editor) => {
    editor.registerExternalAssetHandler("url", getBookmarkPreview);
    editor.updateInstanceState({ isGridMode: true });
    editor.zoomToFit({ animation: { duration: 800 } });
    if (!access) editor.setCurrentTool("hand");
    else editor.setCurrentTool("draw");
    editorRef.current = editor;
  };
  useEffect(() => {
    if (access && editorRef) {
      interval = setInterval(() => {
        saveThumbnail(editorRef.current);
      }, 10000);
    }
    return () => {
      clearInterval(interval);
    };
  }, [access, editorRef]);

  const store = useSync({
    uri: `${TLDRAW_WORKER_URL}/connect/${roomId}`,
    assets: multiplayerAssetStore,
  });
  const components = !access ? { Toolbar: null,StylePanel : null , QuickActions: null, ActionsMenu: null } : "";
  return (
    <>
      <div ref={divRef} className="board-screen">
        <Tldraw store={store} onMount={handleMount} components={components} user={user} forceMobile={true}></Tldraw>
      </div>
    </>
  );
};

export default Board;
